import { colors } from "@hubrise/react-components"
import styled from "styled-components"

export const NoneOption = styled.div`
  padding-bottom: 0.5rem;
  margin-bottom: -0.5rem;
  border-bottom: 1px solid ${colors.borderMedium};
`
